/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import VideoJS from '@components/videojs/VideoJS';
// import { useRouter } from 'next/router';
import videojs from 'video.js';
const typeVal = (url: string) => {
    return !!url && url.includes('m3u8') ? 'application/x-mpegURL' : 'video/mp4';
};

/** 未来可能要区分mp4和直播的逻辑及播放器插件更换，暂时copy了份一样的组件使用。
 * 此组件仅用于处理mp4播放逻辑
 */
export const PopupVideo = ({ enabled, videoURL, onClose, videoPoster, contentBlock }: any) => {
    const playerRef = React.useRef(null);
    // const router = useRouter();
    const videoJsOptions = {
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        autoplay: true,
        controls: true,
        responsive: true,
        fluid: true,
        fill: true,
        preload: 'metadata',
        sources: [
            {
                src: videoURL,
                type: typeVal(videoURL),
                // type: typeVal(content.liveStreamingSource.value),
            },
        ],
        disablePictureInPicture: true,
        controlBar: {
            fullscreenToggle: false, // Disable the fullscreen toggle button
        },
        poster: videoPoster || '',
    };

    // const exitFullscreen = () => {
    //     const doc = document as any;
    //     if (doc.exitFullscreen) {
    //         doc.exitFullscreen();
    //     } else if (doc.mozCancelFullScreen) {
    //         // Firefox
    //         doc.mozCancelFullScreen();
    //     } else if (doc.webkitExitFullscreen) {
    //         // Chrome, Safari and Opera
    //         doc.webkitExitFullscreen();
    //     } else if (doc.msExitFullscreen) {
    //         // Internet Explorer and Edge
    //         doc.msExitFullscreen();
    //     }
    // };

    // const isFullscreen = () => {
    //     const doc = document as any;
    //     return doc.webkitDisplayingFullscreen || doc.fullscreenElement;
    // };

    const handlePlayerReady = (player: any) => {
        playerRef.current = player;
        videoNativePlayer();
        const closeButton = document.createElement('button');
        closeButton.className = 'close-button absolute top-[5vw] right-[5vw] !text-[45px] z-10';
        closeButton.innerHTML = `&times;`;
        player.controlBar.removeChild('FullscreenToggle');
        player.controlBar.removeChild('PictureInPictureToggle');
        closeButton.addEventListener('click', () => {
            // player.exitFullscreen();
            player.dispose();
            if (document.pictureInPictureEnabled && document.pictureInPictureElement) {
                document.exitPictureInPicture();
            }
            onClose();
        });

        player.el().appendChild(closeButton);
        player.play();
        player.on('fullscreenchange', () => {
            // exitFullscreen();
            setTimeout(() => {
                if (
                    !player.isFullscreen() &&
                    !player.el().classList.contains('vjs-picture-in-picture')
                ) {
                    player.dispose();
                    onClose();
                }
            }, 100);
        });

        player.on('leavepictureinpicture', () => {
            setTimeout(() => {
                if (
                    !player.isFullscreen() &&
                    !player.el().classList.contains('vjs-picture-in-picture')
                ) {
                    player.dispose();
                    onClose();
                }
            }, 100);
        });

        // player.disablePictureInPicture();
        player.on('dispose', () => {
            player.dispose();
        });
    };
    const videoNativePlayer = () => {
        const getLivePlayerID = JSON.parse(sessionStorage.getItem('playerLiveId') ?? '[]');
        const getPlayerID = JSON.parse(sessionStorage.getItem('playerId') ?? '[]');
        //Stop all type native video, including MP4 and LiveStream
        getLivePlayerID?.length > 0 &&
            getLivePlayerID.forEach((i: string) => {
                if (document.getElementById(i)) {
                    const player = videojs(i);
                    // 暂停播放
                    player.pause();
                }
            });

        getPlayerID?.length > 0 &&
            getPlayerID.forEach((i: string) => {
                if (document.getElementById(i)) {
                    const player = videojs(i);
                    // 暂停播放
                    player.pause();
                }
            });
    };

    return (
        <>
            {enabled && (
                <div className='fixed top-0 left-0 z-50 w-[100vw] h-[100vh]'>
                    {/* <button
                        onClick={() => {
                            if (
                                document.pictureInPictureEnabled &&
                                document.pictureInPictureElement
                            ) {
                                document.exitPictureInPicture();
                            }
                            onClose();
                        }}
                        className='close-button text-[#fff] absolute top-[0] right-[5vw] !text-[45px] z-10'
                    >
                        ×
                    </button> */}
                    <VideoJS
                        options={videoJsOptions}
                        onReady={handlePlayerReady}
                        autoFullscreen={true}
                        contentBlock={contentBlock}
                    />
                </div>
            )}
        </>
    );
};

export default PopupVideo;
